import { useState } from "react";
import { ChevronDown } from "lucide-react";

const STATES = ["Andhra Pradesh", "Assam", "Bihar", "Chhattisgarh", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
  "Madhya Pradesh", "Maharashtra", "Odisha", "Punjab", "Rajasthan", "Tamil Nadu", "Telangana", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Other"];
const cls = "w-full h-9 rounded-md bg-slate-900 border border-slate-700 px-3 text-sm";

export function BillingFields({ value, onChange, country }) {
  const [open, setOpen] = useState(false);
  const set = (k) => (e) => onChange({ ...value, country, [k]: k === "gstin" ? e.target.value.toUpperCase() : e.target.value });
  const indian = country === "IN";
  return (
    <div className="mt-4 border border-slate-800 rounded-md" data-testid="billing-fields">
      <button type="button" onClick={() => setOpen(!open)} data-testid="billing-toggle" className="w-full flex items-center justify-between px-3 py-2 text-xs text-slate-300">
        Billing details for invoice {indian ? "(GSTIN optional)" : "(optional)"}<ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 grid gap-2">
          <input className={cls} placeholder="Company / billing name" value={value.company || ""} onChange={set("company")} data-testid="billing-company" />
          <input className={cls} placeholder="Billing address" value={value.address || ""} onChange={set("address")} data-testid="billing-address" />
          {indian && (
            <>
              <input className={cls} placeholder="GSTIN (15 characters)" maxLength={15} value={value.gstin || ""} onChange={set("gstin")} data-testid="billing-gstin" />
              <select className={cls} value={value.state || ""} onChange={set("state")} data-testid="billing-state"><option value="">State</option>{STATES.map((s) => <option key={s}>{s}</option>)}</select>
            </>
          )}
          {value.gstin && !/^[0-9]{2}[A-Z0-9]{13}$/.test(value.gstin) && <p className="text-[11px] text-red-400">GSTIN should be 15 characters starting with the 2-digit state code</p>}
        </div>
      )}
    </div>
  );
}
